'use client'
import { useState } from "react";
import { Menu, X } from "@/assets/icons";
import { Button, SmartLink } from "@/components/ui";

export function MobileMenu({ user }: { user: { name: string } | null }) {
    const [menuOpen, setMenuOpen] = useState<boolean>(false);

    return (
        <div className="flex md:hidden pr-20">
            <div className="flex relative">

                <Button
                    onClick={() => setMenuOpen(menuOpen ? false : true)}>
                    <Menu className={`size-6 ${menuOpen ? 'hidden' : 'flex'}`} />
                    <X className={`size-6 z-20 ${menuOpen ? 'flex' : 'hidden'}`} />
                </Button>

                <div className={`${menuOpen ? 'flex' : 'hidden'}`}>
                    <div className="absolute mt-8 -left-12 flex flex-col bg-light_secondary h-screen min-w-12 z-10 p-8 gap-6 shadow-xs dark:bg-dark_secondary">

                        <SmartLink type={"external"} route={"home"} onClick={() => setMenuOpen(false)}
                            className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                            Home
                        </SmartLink>

                        <SmartLink type={"external"} route={"segmentsSto"} onClick={() => setMenuOpen(false)}
                            className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                            Varejo
                        </SmartLink>

                        <SmartLink type={"external"} route={"segmentsSer"} onClick={() => setMenuOpen(false)}
                            className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                            Serviços
                        </SmartLink>

                        <SmartLink type={"external"} route={"segmentsFac"} onClick={() => setMenuOpen(false)}
                            className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                            Industria
                        </SmartLink>

                        <SmartLink type={"external"} route={"segmentsDis"} onClick={() => setMenuOpen(false)}
                            className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                            Distribuidora
                        </SmartLink>

                        <SmartLink type={"external"} route={"segmentsRur"} onClick={() => setMenuOpen(false)}
                            className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                            Produtor Rural
                        </SmartLink>

                        <SmartLink type={"external"} route={"blog"} onClick={() => setMenuOpen(false)}
                            className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                            Blog
                        </SmartLink>

                        <SmartLink type={"external"} route={"products"} onClick={() => setMenuOpen(false)}
                            className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                            Produtos
                        </SmartLink>

                        <SmartLink type={"external"} route={"business"} onClick={() => setMenuOpen(false)}
                            className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                            Empresa
                        </SmartLink>

                        {user
                            ? <SmartLink type={"internal"} route={"home"} onClick={() => setMenuOpen(false)}
                                className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                                Sistema
                            </SmartLink>
                            : ''}

                    </div>
                    <div onClick={() => setMenuOpen(false)} className="absolute w-screen h-screen -mt-7 -ms-16 cursor-pointer" />
                </div>

            </div>

        </div>
    )
}